/* eslint-disable global-require */
import './assets/css/main.scss';
import React from 'react';
import { Provider } from 'react-redux';
import {
  Redirect, Route, Switch, Router,
} from 'react-router-dom';
import './icons';
import { createRoot } from 'react-dom/client';
import { store } from './store';
import { View } from './components/view/View';
import { history } from './history';
import 'leaflet';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import '@geoman-io/leaflet-geoman-free';
import { start as startSessionMonster } from './sessionMonster';
import { Callback } from './components/view/oauth/Callback';
import { BASE_PATH } from './basePath';


const container = document.getElementById('root');
const root = createRoot(container);

startSessionMonster(store);

root.render(
  <div className="haz-root" role="main">
    <a className="skiptocontent" href="#maincontent">Skip to Main Content</a>
    <Provider store={store}>
      <Router history={history} basename={BASE_PATH}>
        <div>
          <Switch>
            <Route exact path="/view/callback" component={Callback} />
            <Route path="/view" render={props => (<View {...props} basePath="/view" />)} />
            <Redirect to="/view" />
          </Switch>
        </div>
      </Router>
    </Provider>
  </div>,
);

history.listen(() => {
  window.scrollTo(0, 0);
});
